export default __webpack_public_path__ + "static/media/bg-example-hkh1.af45d6ba.jpg";